<template>
    <div class="select_dialog_embed">
      <div class="proprietary_costs_embed_msg">
        <div class="select_dialog_embed_box" :class="{'w660': showType === 'log'}">
          <!--弹出框头部-->
          <div class="select_dialog_embed_box_top">
            <p>{{title}}</p>
          </div>

          <!--弹出框信息-->
          <!--日志-->
          <div v-if="showType === 'log'" class="select_dialog_embed_box_content">
            <table class="table">
              <thead>
              <tr>
                <th>操作人</th>
                <th>内容</th>
                <th>修改时间</th>
              </tr>
              </thead>
              <tbody v-if="logList">
              <tr v-for="(item, index) in logList" :key="index">
                <td>{{item.CreaterId}}</td>
                <td>{{item.Info}}</td>
                <td>{{item.CreateTime | time}}</td>
              </tr>
              </tbody>
              <tbody v-if="!logList.length">
              <tr>
                <td colspan="3">{{txtMsg}}</td>
              </tr>
              </tbody>
            </table>
          </div>

          <!--上传信息-->
          <div v-if="showType === 'import'" class="select_dialog_embed_box_content text_center mt20 mb10">
            <input type="file" placeholder="选择文件" @change="tirggerFile($event)" accept=".xls,.xlsx">
          </div>

          <!--弹出框底部-->
          <div class="select_dialog_embed_box_bottom pb15">
            <button v-if="showType === 'import'" class="btn_normal" @click="submitBtn()">上传</button>
            <button class="btn_cancel" @click="cancelBtn(false, false)">取消</button>
          </div>
        </div>
      </div>

      <!--信息提示框-->
      <msg-dialog v-if="isMsg"
                  :is-suc="isSuc"
                  :txt="txtMsg" @closebtn="closeMsgDialog"></msg-dialog>

      <!--加载框-->
      <loading-dialog v-if="isLoading" :type="loadingType"></loading-dialog>
    </div>
</template>

<script>
  import MsgDialog from '../../public-component/msg-dialog';
  import LoadingDialog from '../../public-component/loading-dialog';

  export default {
    name: 'proprietary-costs-embed-msg',
    /**
     *  title：  头部名
     *  showType: 显示类型
     *  shopMsg: 店铺信息
     * */
    props: ['title', 'showType', 'msg'],
    components: {MsgDialog, LoadingDialog},
    data() {
      return {
        logList: [], // 日志列表
        importFile: null, // 上传文件
        isLoading: false, // 是否显示加载框
        loadingType: 'NOP', // 加载页面类型
        isMsg: false, // 信息框显示
        isSuc: false, // 是否成功
        txtMsg: '暂时没有相关的数据' // 信息框内容
      }
    },
    methods: {
      // 获取成本日志数据
      getSelfCostLog() {
        this.$axios.post(this.Global.getSelfCostLog(this.msg.goodsNum, this.msg.storeroomId), null).then((res) => {
          console.log(res);
          if (res) {
            if (!res.data.errorMsg.length) {
              this.logList = res.data.resData;
            } else {
              this.txtMsg = res.data.errorMsg;
            }
          } else {
            this.txtMsg = '暂时没有相关的数据';
          }
        });
      },

      // 获取文件
      tirggerFile(e) {
        this.importFile = e.target.files;
      },

      // 导入自营仓货品Excel【仅支持文件放在FormData方式上传】
      importSelfCostExcel() {
        if (!this.importFile) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请选择要导入的文件';
          return;
        }
        this.isLoading = true;
        this.loadingType = 'options';
        const formData = new FormData();
        formData.append('body', this.importFile[0]);
        this.$axios.post(this.Global.importSelfCostExcel, formData).then((res) => {
          let timer;
          const self = this;
          timer = setTimeout(function () {
            clearTimeout(timer);
            self.isLoading = false;
            if (res) {
              if (res.data.errorMsg.length) {
                self.isMsg = true;
                self.isSuc = false;
                self.txtMsg = res.data.errorMsg;
                window.open(res.data.resData, '_blank');
              } else {
                self.isMsg = true;
                self.isSuc = true;
                self.txtMsg = '导入成功';
                self.cancelBtn(true);
              }
            }
          }, 500);
        });
      },

      // 提交按钮
      submitBtn() {
        if (this.showType === 'import') {
          this.importSelfCostExcel();
        }
      },

      // 取消按钮
      cancelBtn(type) {
        this.$emit('cancelbtn', {isShow: false, handleType: type});
      },

      // 接收提示框传送的数据
      closeMsgDialog(e) {
        this.isMsg = e;
        if (this.isSuc) {
          this.cancelBtn(true);
        }
      }
    },
    created() {
      if (this.showType === 'log') {
        this.getSelfCostLog();
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/css/home-view";

  .proprietary_costs_embed_msg{
    .select_dialog_embed_box {
      &.w660 {
        width: 660px;
      }

      table {
        margin: 10px;
        width: calc(100% - 20px);

        th, td {
          border: 1px solid #ddd;
          max-width: 420px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/report-management/proprietary-costs-embed-msg.vue